import InitializePage from './Page';
export default InitializePage;
